import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    // @ts-expect-error - this probably works
    return originalPush.call(this, location).catch(error => {
        if (error.name !== 'NavigationDuplicated' &&
            !error.message.includes('Avoided redundant navigation to current location')) {
            throw error;
        }
    });
};
Vue.use(VueRouter);
const routes = [
    {
        path: '/:namespace/shared/dashboard/:token',
        name: 'SharedDashboard',
        component: () => import(/* webpackChunkName: "shared-dashboard" */ '@/views/SharedDashboard.vue'),
        meta: { requiresAuthentication: false }
    },
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        alias: '/index.html',
        meta: { menuKey: 'dashboard' }
    },
    {
        path: '/checkins-checkouts',
        name: 'ActionsItems',
        component: () => import(/* webpackChunkName: "action-items" */ '@/views/ActionItems.vue'),
        meta: { menuKey: 'checkins-checkouts' }
    },
    {
        path: '/map/:positionId?',
        name: 'Map',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "map" */ '@/views/Map.vue'),
        meta: { menuKey: 'map' }
    },
    {
        path: '/calendar',
        name: 'Calendar',
        component: () => import(/* webpackChunkName: "calendar" */ '@/views/Calendar.vue'),
        meta: { menuKey: 'calendar' }
    },
    {
        path: '/orders',
        name: 'Orders',
        component: () => import(/* webpackChunkName: "orders" */ '@/views/pos/Orders.vue'),
        meta: { menuKey: 'orders' }
    },
    {
        path: '/units/:tab?',
        name: 'Units',
        component: () => import(/* webpackChunkName: "units" */ '@/views/pos/Units.vue'),
        meta: { menuKey: 'units' }
    },
    {
        path: '/cleaning/:tab?',
        name: 'Cleaning',
        component: () => import(/* webpackChunkName: "cleaning" */ '@/views/Cleaning.vue'),
        meta: { menuKey: 'cleaning' }
    },
    {
        path: '/register/:chargable?/:id?/:checkout?', // chargable är 'booking', 'order' eller 'booking-group'
        name: 'PosRegister',
        component: () => import(/* webpackChunkName: "register" */ '@/views/pos/Register.vue'),
        meta: { menuKey: 'register' }
    },
    {
        path: '/receipts',
        name: 'Receipts',
        component: () => import(/* webpackChunkName: "receipts" */ '@/views/pos/Receipts.vue'),
        meta: { menuKey: 'receipts' }
    },
    {
        path: '/products/:tab?',
        name: 'Products',
        component: () => import(/* webpackChunkName: "products" */ '@/views/admin/Products.vue'),
        meta: { menuKey: 'products' }
    },
    {
        path: '/invoices',
        name: 'Invoices',
        component: () => import(/* webpackChunkName: "invoices" */ '@/views/admin/Invoices.vue'),
        meta: { menuKey: 'invoices' }
    },
    {
        path: '/bookings/:tab?',
        name: 'Bookings',
        component: () => import(/* webpackChunkName: "bookings" */ '@/views/Bookings.vue'),
        meta: { menuKey: 'bookings' }
    },
    {
        path: '/bookvisit/:tab?',
        name: 'Bookvisit',
        component: () => import(/* webpackChunkName: "bookvisit" */ '@/views/Bookvisit.vue')
    },
    {
        path: '/bankgiro',
        name: 'Bankgiro',
        component: () => import(/* webpackChunkName: "bankgiro" */ '@/views/admin/Bankgiro.vue'),
        meta: { menuKey: 'bankgiro' }
    },
    {
        path: '/accounting/:tab?',
        name: 'Accounting',
        component: () => import(/* webpackChunkName: "accounting" */ '@/views/admin/Accounting.vue'),
        meta: { menuKey: 'accounting' }
    },
    {
        path: '/settings/:tab?',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/admin/Settings.vue'),
        meta: { menuKey: 'settings' }
    },
    {
        path: '/reports-and-exports/:tab?',
        name: 'ListLibrary',
        component: () => import(/* webpackChunkName: "list-library" */ '@/views/admin/ListLibrary.vue'),
        meta: { menuKey: 'reports-and-exports' }
    },
    {
        path: '/statistics',
        name: 'Statistics',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/Statistics.vue'),
        meta: { menuKey: 'statistics' }
    },
    {
        path: '/sales-reports',
        name: 'SalesReports',
        component: () => import(/* webpackChunkName: "sales-reports" */ '@/views/statistics/SalesReports.vue'),
        meta: { menuKey: 'sales-reports' }
    },
    {
        path: '/tvv-statistics',
        name: 'Inkvarteringsstatistik',
        component: () => import(/* webpackChunkName: "tvv-statistics" */ '@/views/statistics/Scb.vue'),
        meta: { menuKey: 'tvv-statistics' }
    },
    {
        path: '/scr',
        name: 'Scr',
        component: () => import(/* webpackChunkName: "scr" */ '@/views/admin/Scr.vue'),
        meta: { menuKey: 'scr' }
    },
    {
        path: '/reservations',
        component: () => import(/* webpackChunkName: "reservations" */ '@/components/reservations/ReservationsLayout.vue'),
        meta: { menuKey: 'reservations' },
        children: [
            {
                path: 'today',
                name: 'TodaysReservations',
                component: () => import(/* webpackChunkName: "reservations-today" */ '@/views/reservations/TodaysReservationsPage.vue')
            },
            {
                path: 'reservations',
                name: 'ReservationsAll',
                component: () => import(/* webpackChunkName: "reservations-all" */ '@/components/reservations/AllReservationsTab.vue')
            },
            {
                path: 'products',
                name: 'AllReservableProducts',
                component: () => import(/* webpackChunkName: "reservations-items" */ '@/views/reservations/AllReservableProductsPage.vue')
            },
            {
                path: 'reservation-overview',
                name: 'ReservationOverview',
                component: () => import(/* webpackChunkName: "reservation-overview" */ '@/views/reservations/ReservationOverviewPage.vue')
            },
            {
                path: 'forsaljning/:tab?',
                name: 'ReservationSales',
                component: () => import(/* webpackChunkName: "reservations-sales" */ '@/views/reservations/ReservationSalesPage.vue')
            },
            {
                // Självincheckning var en egen flik innan den flyttade in under Försäljning
                path: 'selfcheckin',
                name: 'ReservationSelfCheckinSettings',
                redirect: { name: 'ReservationSales', params: { tab: 'sjalvincheckning' } }
            },
            {
                path: '*',
                redirect: {
                    name: 'TodaysReservations'
                }
            }
        ]
    },
    {
        // Måste vara sist för att fungera
        path: '*',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "not-found" */ '@/views/PageNotFound.vue')
    }
];
const router = new VueRouter({
    mode: process.env.IS_ELECTRON ? 'hash' : 'history',
    routes
});
export default router;
